const maskO = document.getElementById('mask-o');
const bgBlue = document.getElementById('bg-blue');
const filterOffset = document.getElementById('filterOffset');

let angle = 0;

function frame() {
  angle = (angle + 0.05) % 360;
  maskO.setAttribute('transform', `translate(${-Math.sin((angle + 40) / 180 * Math.PI) * 8}, ${-Math.cos((angle + 40) / 180 * Math.PI) * 8}) rotate(${angle})`);
  bgBlue.setAttribute('transform', `translate(${Math.sin(angle / 180 * Math.PI) * 10 + 10}, ${Math.cos(angle / 180 * Math.PI) * 10 - 5})`);
  requestAnimationFrame(frame);
}

frame();
